export const FORBIDDEN_KEYS = ['__proto__', 'constructor', 'prototype'];

// Prevent Prototype Pollution
export function sanitizeKey(key: string): string | null {
    return FORBIDDEN_KEYS.includes(key) ? null : key;
}
